import React, { useState } from "react";
import "./volunteerDetails.scss";

import { Stack } from "react-bootstrap";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CustomDialog from "../customDialog/CustomDialog";
import { isEmpty } from "../../utils/validation";

/**
 ListSettingsVoice = {
  id: 1, 
  name: "Rendi amministratore"
  icon: <REMOVEICON/>
  color: "#000"
  callback: () => {}
  customDialog = true | false
  titleModal: ""
  descriptionModal: ""
}
*/
const VolunteerDetails = ({
  id,
  image,
  name,
  surname,
  phoneNumber,
  email,
  listSettingsVoice,
  role,
}) => {
  const [viewDetails, setViewDetails] = useState(false);

  const iconStyle = {
    color: "#549843",
    height: "24px",
    width: "24px",
  };

  return (
    <div
      className="volunteer-details-container"
      style={{ height: viewDetails ? "100%" : "100px" }}
    >
      <Stack direction="vertical" gap={2} className="p-2">
        <Stack
          direction="horizontal"
          className="d-flex justify-content-between aligin-items-center"
          gap={1}
          style={{ cursor: "pointer" }}
          onClick={() => setViewDetails(!viewDetails)}
        >
          <Stack direction="horizontal" gap={3}>
            <img alt="img-profile" src={image ?? "/no_img.png"} />
            <Stack
              direction="vertical"
              className="d-flex justify-content-center"
            >
              <span className="name-surname-volunteer">
                {name} {surname}
              </span>
              {role ? <span className="role-volunteer">{role}</span> : null}
            </Stack>
          </Stack>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => setViewDetails(!viewDetails)}
          >
            {viewDetails ? (
              <ArrowDropUpIcon style={iconStyle} />
            ) : (
              <ArrowDropDownIcon style={iconStyle} />
            )}
          </div>
        </Stack>

        {viewDetails ? (
          <Stack direction="vertical" gap={0} className="mt-3">
            {/*Numero di telefono */}
            <Stack
              direction="horizontal"
              gap={4}
              className="more-info-stack-horizontal"
            >
              <CallOutlinedIcon style={iconStyle} />
              <span className="volunteer-information">{phoneNumber}</span>
            </Stack>
            {/*email del volontario */}
            <Stack
              direction="horizontal"
              gap={4}
              className="more-info-stack-horizontal"
            >
              <EmailOutlinedIcon style={iconStyle} />
              <span className="volunteer-information">{email}</span>
            </Stack>
            {!isEmpty(listSettingsVoice)
              ? listSettingsVoice.map((item, index) => {
                  const content = (
                    <Stack
                      key={index}
                      direction="horizontal"
                      gap={4}
                      onClick={!item.customDialog ? item.callback : undefined} // Evita onClick se è un dialog
                      className="more-info-stack-horizontal"
                    >
                      {item.icon}
                      <span
                        className="volunteer-information"
                        style={{ color: item.color }}
                      >
                        {item.name}
                      </span>
                    </Stack>
                  );
                  if (item.customDialog) {
                    return (
                      <CustomDialog
                        key={index}
                        title={item.titleModal}
                        body={item.descriptionModal}
                        callback={() => {
                          item.callback();
                        }}
                        trigger={content}
                      />
                    );
                  } else {
                    return content;
                  }
                })
              : null}
          </Stack>
        ) : null}
      </Stack>
    </div>
  );
};

export default VolunteerDetails;
